<template>
  <div
      class="floating-tooltip"
      :class="{visible: tooltip.active && !touch}"
      ref="tooltip"
      v-if="tooltip.text"
      :style="position"
      v-html="tooltip.text">
  </div>
</template>

<script>


import {mapGetters} from "vuex";

export default {
  data() {
    return {
      touch: null,
      x: 0,
      y: 0,
      windowWith: 0,
      windowHeight: 0,
      tooltipWidth: 0,
      tooltipHeight: 0
    }
  },
  mounted() {
    document.addEventListener('mousemove', this.onMouseMove);
    this.touch = 'ontouchstart' in window;
  },
  methods: {
    onMouseMove(e) {
      if (this.tooltip.active) {
        this.windowWith = window.innerWidth;
        this.windowHeight = window.innerHeight;

        if (this.$refs.tooltip && this.$refs.tooltip.getClientRects()) {
          this.tooltipWidth = this.$refs.tooltip.getClientRects()[0]?.width;
          this.tooltipHeight = this.$refs.tooltip.getClientRects()[0]?.height;

          if (e.clientX + this.tooltipWidth / 2 >= this.windowWith) {
            this.x = this.windowWith - this.tooltipWidth / 2;
          } else if (e.clientX < this.tooltipWidth / 2) {
            this.x = this.tooltipWidth / 2;
          } else {
            this.x = e.clientX;
          }
        } else {
          this.x = e.clientX;
        }

        this.y = e.clientY;
      }
    }
  },
  computed: {
    ...mapGetters(['tooltip']),
    position() {
      return {
        left: `${this.x}px`,
        top: `${this.y}px`
      }
    }
  }
}
</script>